// extracted by mini-css-extract-plugin
export var container = "_hg-0";
export var dotAnimation = "_hg-2";
export var dotsLoading = "_hg-1";